<template>
  <span>
    <div class="GQN9PQ" v-for="(item, idx) in value.vessels" :key="idx">
      <div class="Ka3O3w">
        <div class="yKQVPS">Vessel</div>
        <div class="I4TWtc">{{ item.name }}</div>
      </div>

      <div class="Ka3O3w">
        <div class="yKQVPS">Voyage</div>
        <div class="I4TWtc">
          {{ listEvents.find((e) => e.vessel == idx + 1).voyage }}
        </div>
      </div>

      <div class="Ka3O3w">
        <div class="yKQVPS">Loading</div>
        <div class="I4TWtc">
          {{
            value.locations.find(
              (l) =>
                l.id ==
                listEvents.filter((e) => e.vessel == idx + 1)[0].location
            ).name
          }},
          {{
            value.locations.find(
              (l) =>
                l.id ==
                listEvents.filter((e) => e.vessel == idx + 1)[0].location
            ).country_code
          }}
        </div>
      </div>

      <div class="Ka3O3w">
        <div class="yKQVPS">Discharge</div>
        <div class="I4TWtc">
          {{
            value.locations.find(
              (l) =>
                l.id ==
                listEvents.filter((e) => e.vessel == 1)[
                  listEvents.filter((e) => e.vessel == 1).length - 1
                ].location
            ).name
          }},
          {{
            value.locations.find(
              (l) =>
                l.id ==
                listEvents.filter((e) => e.vessel == 1)[
                  listEvents.filter((e) => e.vessel == 1).length - 1
                ].location
            ).country_code
          }}
        </div>
      </div>
      <div class="Ka3O3w">
        <div class="yKQVPS">ATD</div>
        <div class="I4TWtc">
          {{
            moment(
              listEvents.filter((e) => e.vessel == idx + 1)[0].date
            ).format("DD MMM YYYY ")
          }}
        </div>
      </div>
      <div class="Ka3O3w">
        <div class="yKQVPS">ATA</div>
        <div class="I4TWtc">
          {{
            moment(
              listEvents.filter((e) => e.vessel == idx + 1)[
                listEvents.filter((e) => e.vessel == 1).length - 1
              ].date
            ).format("DD MMM YYYY ")
          }}
        </div>
      </div>
    </div>
  </span>
</template>

<script>
import moment from "moment";

export default {
  props: {
    value: {
      type: Object,
      default: () => [],
    },
  },
  computed: {
    listEvents() {
      return this.value.containers
        .map((c) => c.events)
        .reduce((a, b) => a.concat(b), []);
    },
  },
  data() {
    return {
      moment,
    };
  },
  mounted() {
  },
};
</script>
